import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import classNames from 'classnames';

const Option = styled.div.attrs({
  className: 'flex items-center my-5 px-4 w-1/2 sm:w-full sm:my-2',
})`
  .content {
    background: rgba(98, 120, 140, 0.05);
    border-radius: 10px;
    padding: 25px;

    label {
      line-height: 14px;
    }

    div {
      min-width: 20px;
    }

    @media only screen and (max-width: 639px) {
      padding: 15px;
    }
  }
`;

const RadioGroup = ({ options, value, className, name, onChange }) => {
  const [val, setVal] = useState(value);

  useEffect(() => setVal(value), [value]);

  const handleChange = (v) => () => {
    setVal(v);
    onChange(v);
  };

  return (
    <div className={` ${className} -mx-4 flex flex-wrap`}>
      {options.map((option, id) => (
        <Option
          key={option.key}
          onClick={handleChange(option.key)}
          checked={val === option.key}
        >
          <div className="content w-full flex items-center">
            <div
              className={classNames(
                'w-5 h-5 rounded-full border-2 border-solid border-black mr-4',
                val === option.key && 'bg-light-yellow'
              )}
            />
            <label className="text-base text-gray-100">
              {option.label}
            </label>
          </div>
        </Option>
      ))}
    </div>
  );
};

export default RadioGroup;
